<template>
  <div class="overlay" :style="getStyle()"></div>
</template>

<script>
export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStyle() {
      const color_40 = this.color + '44';
      return {
        height: `${Number(this.boundingBox.height) + 2}px`,
        top: '-1px',
        left: '-1px',
        position: `absolute`,
        width: `${Number(this.boundingBox.width) + 2}px`,
        border: this.border ? `2px solid ${this.color}` : null,
        background: color_40,
      };
    },
  },
};
</script>
